export enum CabinetTopEnum {
    NONE = -1,
    SOLID_TOP = 24,
    RAIL_ON_EDGE = 25,
    RAIL_ON_FLAT = 26,
    LS_SOLID_TOP = 36,
    LS_RAIL_ON_EDGE = 49,
    LS_RAIL_ON_FLAT = 50,
    FF_RAIL_ON_FLAT = 95,
    FF_SOLID_TOP = 96,
    LS_RAIL_ON_EDGE_LONG_LEFT = 163,
    LS_RAIL_ON_EDGE_LONG_RIGHT = 164,
    LS_TIMBER_RAIL_ON_EDGE_LONG_LEFT = 176,
    LS_TIMBER_RAIL_ON_EDGE_LONG_RIGHT = 177,
    FINGERPULL_NO_TOP = 226,
    FINGERPULL_RAIL_TOP = 229,
}
